import {Button, ButtonGroup} from '@/components/atoms'
import PropTypes from 'prop-types'

/**
 * SaveCancelFooter component renders a footer with Cancel, Save Draft, and Next/Publish buttons.
 *
 * @param {Object} props - The component props.
 * @param {Function} props.handleCancel - Function to handle the cancel action.
 * @param {Function} props.draftAction - Function to handle the save draft action.
 * @param {Function} props.nextAction - Function to handle the next or publish action.
 * @param {boolean} [props.isReview=false] - Flag to determine if the current step is review.
 * @param {Array} [props.FormError=[]] - Array of form errors to determine if the next button should be disabled.
 *
 * @returns {JSX.Element} The rendered SaveCancelFooter component.
 */
const SaveCancelFooter = ({
  handleCancel,
  draftAction,
  nextAction,
  isReview = false,
  hideSaveDraft,
  FormError = false,
}) => {
  const saveDraftSchema = () => {
    if (hideSaveDraft) {
      return [
        {
          label: 'Cancel',
          onClick: handleCancel,
        },
      ]
    } else {
      return [
        {
          label: 'Cancel',
          onClick: handleCancel,
        },
        {
          label: 'Save Draft',
          onClick: draftAction,
        },
      ]
    }
  }

  return (
    <div className="flex justify-between py-4">
      <ButtonGroup
        uiSchema={{
          items: saveDraftSchema(),
        }}
      />
      <Button
        handleButton={nextAction}
        uiSchema={{
          className: 'ml-4',
          title: isReview ? 'Publish' : 'Next',
          variant: 'primary',
          size: 'medium',
          iconTrailing: 'arrow_forward',
          disabled: FormError,
        }}
      />
    </div>
  )
}

SaveCancelFooter.propTypes = {
  handleCancel: PropTypes.func,
  draftAction: PropTypes.func,
  nextAction: PropTypes.func,
  isReview: PropTypes.bool,
  hideSaveDraft: PropTypes.bool,
  FormError: PropTypes.bool,
}

export default SaveCancelFooter
